export default{
    CREATE_COURSE(state, payload){
        state.createcourse = payload;
    },
    GET_COURSE_DATA(state, payload){
        state.courseList = payload;
    },
    GET_SINGLE_COURSE(state, payload){
        state.courseDetails = payload;
    },
}